export default "__VITE_ASSET__B9H8nJ0j__"